import React from 'react'
import PropTypes from 'prop-types'
import { sh, compose, ReduxWrapper } from 'common-data/datahelpers'
import _ from 'common-tools/LodashHelper'

export function buildImageURL (key, token, query) {
  if (_.isObject(query)) {
    var params = _.join(_.map(_.toPairs(query), (q) => (`&${q[0]}=${q[1]}`)), '')
    return `/Files/Get/${key}/?token=${token}${params}`
  } else {
    return `/Files/Get/${key}/?token=${token}`
  }
}

export class ImgURLPlain extends React.Component {
  static propTypes = {
    src: PropTypes.string,
    pictureKey: PropTypes.string
  }

  render () {
    const { src, pictureKey, SessionToken, dispatch, ...rest } = this.props

    var fixedURL = null

    if (pictureKey) {
      fixedURL = buildImageURL(pictureKey, SessionToken)
    } else {
      fixedURL = src
    }

    return (
      <img src={fixedURL} {...rest} />
    )
  }
}

export const ImgURL = compose(
  ReduxWrapper([
    sh.SessionToken
  ], [ ])
)(ImgURLPlain)

export default ImgURL
